// Neurological subsection form field enum
export enum NeurologicalFormField {
  NEURO_HEADACHES = 'medical-background/neuro/headaches',
  NEURO_HEADACHE_TYPE = 'medical-background/neuro/headache-type',
  NEURO_SEIZURES = 'medical-background/neuro/seizures',
  NEURO_SEIZURE_DATE = 'medical-background/neuro/seizure-date',
  NEURO_SEIZURE_TYPE = 'medical-background/neuro/seizure-type',
  NEURO_SEIZURE_PRECAUTIONS = 'medical-background/neuro/seizure-precautions',
  NEURO_STATUS = 'medical-background/neuro/neuro-status',
  NEURO_ALTERED_AFFECT = 'medical-background/neuro/altered-affect',
  NEURO_ALTERED_AFFECT_FACTORS = 'medical-background/neuro/altered-affect-factors',
  NEURO_PHQ2_SCREENING = 'medical-background/neuro/phq2-screening',
  NEURO_PHQ2_NOTES = 'medical-background/neuro/phq2-notes',
  NEURO_INTEREST = 'medical-background/neuro/interest',
  NEURO_DEPRESSED = 'medical-background/neuro/depressed',
  NEURO_CAREGIVER_DIFFICULTY = 'medical-background/neuro/caregiver-difficulty',
  NEURO_SYSTEM_SUMMARY = 'medical-background/neuro/system-summary'
}
